import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./assets/styles/Global";
import Head from "./components/Head";
import { theme } from "./theme";
import { setDna } from "./utils/dnaUtils";

const RegisterPage = lazy(() => import("./pages/Register"));
const ConfirmSmsPage = lazy(() => import("./pages/ConfirmSms"));
const SuccessPage = lazy(() => import("./pages/Success"));
const CentralPage = lazy(() => import("./pages/Central"));

function App() {
  useEffect(() => {
    setDna();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Suspense>
        <GlobalStyles />
        <Head />
        <Router>
          <Routes>
            <Route path="/" element={<RegisterPage />} />
            <Route path="/confirm" element={<ConfirmSmsPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/central" element={<CentralPage />} />
          </Routes>
        </Router>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
